<template>
  <section class="bg-[#f7f7f7] py-10">
    <div class="md:px-10 max-w-screen-4xl mx-auto px-6 lg:px-12">
      <div class="text-center">
        <h2 class="text-xl font-semibold text-yellow story-style">
          FREQUENTLY ASKED QUESTIONS
        </h2>
        <p class="mt-4 mb-6 text-gray-600">
          Welcome to our FAQ section where we answered commonly asked questions
          about our products, services, and more. This will give you better
          insight into what we do at Mshel Homes!
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 py-10">
        <div v-for="(faq, index) in faqs" :key="index">
          <div class="bg-white shadow-lg rounded-2xl overflow-hidden">
            <button
              class="w-full text-left px-5 py-3 bg-gray-100 font-semibold text-gray-800 flex justify-between items-center focus:outline-none"
              @click="toggleFAQ(index)"
            >
              <span>{{ faq.question }}</span>
              <svg
                :class="{ 'rotate-180': faq.open }"
                class="w-5 h-5 text-gray-600 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </button>

            <!-- Smooth transition for dropdown content -->
            <transition name="faq-slide">
              <div
                v-if="faq.open"
                class="px-5 py-3 text-gray-600"
              >
                {{ faq.answer }}
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      faqs: [
        {
          question: "What type of property do Mshel Homes Sell?",
          answer:
            "Mshel Homes sells a variety of properties in Abuja, including estate lands, apartments, houses, and commercial spaces. We also offer a variety of payment plans.",
          open: true,
        },
        {
          question: "Is the land payment inclusive of the infrastructure levy?",
          answer:
            "No, the infrastructure levy depends on the plot size and is paid once the building reaches the carcass level.",
          open: true,
        },
        {
          question: "What is Mshel Homes commitment to customer satisfaction?",
          answer:
            "We offer free consultations, property tours, flexible payment plans, and after-sales support to ensure customer satisfaction.",
          open: false,
        },
        {
          question:
            "How do I get started with buying a property from Mshel Homes?",
          answer:
            "Simply visit our website or contact us via phone or email, and we will assist you.",
          open: false,
        },
        {
          question:
            "Can we make adjustments to support a different kind of building design?",
          answer:
            "Yes, you can customize the interior with our design team, but the exterior must remain uniform.",
          open: false,
        },
      ],
    };
  },
  methods: {
    toggleFAQ(index) {
      this.faqs[index].open = !this.faqs[index].open;
    },
  },
};
</script>

<style scoped>
button {
  transition: background-color 0.3s ease-in-out;
}
button:hover {
  background-color: #e2e8f0;
}
.faq-slide-enter-active, .faq-slide-leave-active {
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out;
  overflow: hidden;
}

.faq-slide-enter-from, .faq-slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.faq-slide-enter-to, .faq-slide-leave-from {
  max-height: 200px;
  opacity: 1;
}

.story-style {
  font-family: "Caveat";
}
</style>
